import React from 'react'
import { Done, DoneAll } from '@material-ui/icons'
import { Tooltip } from '@material-ui/core'
import {
  StyledRotatedSyncRounded,
  StyledErrorRounded,
  StyledWrapper,
} from './styled'

const getIcon = (all: boolean = false) =>
  all ? (
    <DoneAll color="primary" className="auto-done-icon" />
  ) : (
    <Done color="primary" className="auto-done-icon" />
  )

const renderIcon = ({ status, all, genericError }: IFileTreeCheck) => {
  switch (status) {
    case 'done':
      return getIcon(all)
    case 'error':
      return (
        <Tooltip
          title={
            genericError &&
            genericError
              .split('\n')
              .map((message, i) => <div key={i}>{message}</div>)
          }
        >
          <StyledErrorRounded className="auto-error-icon" />
        </Tooltip>
      )
    case 'publishing':
      return (
        <StyledRotatedSyncRounded
          color="primary"
          className="auto-publishing-icon"
        />
      )
  }
}

interface IFileTreeCheck {
  all?: boolean
  status?: 'done' | 'error' | 'publishing'
  genericError?: string | false
}

export const FileTreeCheck = (props: IFileTreeCheck) => (
  <StyledWrapper>{renderIcon(props)}</StyledWrapper>
)
